import React, {useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { i18n, formatNumber, formatDate } from '../../Utility/Format'

import SmallChart from '../Widgets/SmallChart';
import CurrencyChangeValue from '../Widgets/CurrencyChangeValue';
import CurrencyPairLink, { formatCurrencyKey } from '../Helper/CurrencyPairLink';

/**
 * One single widget within a <GridContainer />
 * This is used for the dashboard view. It displays currency pairs and additional information and a chart view in extended state.
 */

const gridItemPropTypes = {
    extended: PropTypes.bool.isRequired,
    ccyPair: PropTypes.string.isRequired,
    chartData: PropTypes.arrayOf(PropTypes.shape({
        timestamp: PropTypes.string,
        bid: PropTypes.number,
        ask: PropTypes.number
    })),
    spot: PropTypes.shape({
        ask: PropTypes.number,
        bid: PropTypes.number,
        changeAbsolute: PropTypes.number,
        changePercent: PropTypes.number,
        previousBid: PropTypes.number,
        previousAsk: PropTypes.number,
        valueDate: PropTypes.string
    }).isRequired,
    locale: PropTypes.string
};

// if we only display one black number it should be the average of bid and ask
// information was given by the customer
const average = (first, second) => {
    return (first + second) / 2;
};
 
const GridItem = (props) => {
    let className = classnames('grid-item', {
        'grid-item--extended': props.extended
    });

const [isMobile, setIsMobile] = useState(window.innerWidth <= 675);
 
useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 675);
  };
 
  window.addEventListener("resize", handleResize);
 
  return () => window.removeEventListener("resize", handleResize);
}, []);

    const renderExtendedDetailsTable = () => {
        return (
            <table role="presentation">
                <tbody>
                    <tr className="labels">
                        <td>{props.extended ? i18n('dbm.currency.changePercent') : null}</td>
                        <td>{i18n('dbm.currency.bid')}</td>
                        <td>{i18n('dbm.currency.ask')}</td>
                    </tr>
                    <tr>
                        <td style={{ whiteSpace: 'nowrap', ...(isMobile ?{ fontSize: "0.67333333rem" } :{}) }}><CurrencyChangeValue value={props.spot.changePercent} fractionDigits={2} unit="%" showIcon={true} showText={true} /></td>
                        <td style={  isMobile ?{ fontSize: "0.67333333rem" } :{}}>{formatNumber(props.spot.bid, 4)}</td>
                        <td style={ isMobile ?{ fontSize: "0.67333333rem" } :{}}>{formatNumber(props.spot.ask, 4)}</td>
                        <td style={ isMobile ?{ fontSize: "0.67333333rem" } :{}} className="tabletOnly">{formatNumber(average(props.spot.ask, props.spot.bid), 4)}</td>
                    </tr>
                    <tr className="labels">
                        <td>{props.extended ? i18n('dbm.currency.valueDate') : null}</td>
                        <td>{i18n('dbm.currency.previousBid')}</td>
                        <td>{i18n('dbm.currency.previousAsk')}</td>
                    </tr>
                    <tr>
                        <td style={ isMobile ?{ fontSize: "0.67333333rem" } :{}} >{formatDate(props.spot.valueDate, props.locale)}</td>
                        <td style={ isMobile ?{ fontSize: "0.67333333rem" } :{}} >{props.spot.previousBid ? formatNumber(props.spot.previousBid, 4) : "—"}</td>
                        <td style={ isMobile ?{ fontSize: "0.67333333rem" } :{}} >{props.spot.previousAsk ? formatNumber(props.spot.previousAsk, 4) : "—"}</td>
                    </tr>
                </tbody>
            </table>
        )
    };

    const renderDetailsTable = () => {
        return (
            <table role="presentation">
                <tbody>
                    <tr className="labels">
                        <td>{props.extended ? i18n('dbm.currency.changePercent') : null}</td>
                        <td>{i18n('dbm.currency.bid')}</td>
                        <td>{i18n('dbm.currency.ask')}</td>
                    </tr>                
                
                    <tr>
                        <td style={{ whiteSpace: 'nowrap', ...(isMobile ?{ fontSize: "0.67333333rem" } :{}) }}><CurrencyChangeValue value={props.spot.changePercent} fractionDigits={2} unit="%" showIcon={true} showText={true} /></td>
                        <td style={ isMobile ?{ fontSize: "0.67333333rem" } :{}} >{formatNumber(props.spot.bid, 4)}</td>
                        <td style={ isMobile ?{ fontSize: "0.67333333rem" } :{}} >{formatNumber(props.spot.ask, 4)}</td>
                        <td style={ isMobile ?{ fontSize: "0.67333333rem" } :{}} className="tabletOnly">{formatNumber(average(props.spot.ask, props.spot.bid), 4)}</td>
                    </tr>
                </tbody>
            </table>
        )
    };
    return (
        <div className={className}>
            <div className="grid-item__content">
                <CurrencyPairLink currencyPair={props.ccyPair}>
                    <header className="grid-item__content__header">
                        {formatCurrencyKey(props.ccyPair)}
                        {props.extended ? <small className="u-float--right u-breakpoint--hideForTablet">Intraday</small> : null}
                    </header>

                    {props.extended ? <SmallChart chartData={props.chartData} /> : null}

                    <div className="grid-item__content__details">
                        {props.extended ? renderExtendedDetailsTable() : renderDetailsTable()}
                </div>
                </CurrencyPairLink>
            </div>
        </div>
    )
};

GridItem.propTypes = gridItemPropTypes;

export default GridItem;